import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { default as MUIToolbar } from '@material-ui/core/Toolbar';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      alignItems: 'center',
      justifyContent: 'space-between',
      '& > *': {
        flex: '0 0 auto',
      },
    },
  };
};

class Toolbar extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  render() {
    let { children, classes } = this.props;

    return (
      <MUIToolbar data-testid="toolbar" className={classes.root}>
        {children}
      </MUIToolbar>
    );
  }
}

export default withStyles(styles)(Toolbar);
